import React, { useState, useEffect, Fragment} from 'react';
import Layout from '../../core/Layout';
import { isAuthenticated } from '../../auth';
import { Link } from 'react-router-dom';
import { XCircleIcon } from '@heroicons/react/solid';
import { FileDrop } from 'react-file-drop';
import { Dialog, Transition } from '@headlessui/react';
import Select from 'react-select';
import brands from './brands';
import SuccessModal from '../../core/SuccessModal';
import LinkPaypal from '../LinkPaypal';
import { useLocation } from 'react-router-dom';
import { savePaypal, getUserInfo, createProduct } from '../apiUser';

const AddProduct = () => {
    const { user: {_id}, token } = isAuthenticated();
    const [userInfo, setUserInfo] = useState({
        merchantId: '', 
        paypal_onboarded: false,
    });
    const { merchantId, paypal_onboarded } = userInfo;
    const [productId, setProductId] = useState('');
    const [primaryPreview, setPrimaryPreview] = useState(null);
    const [secondaryPreviews, setSecondaryPreviews] = useState([]);

    const search = useLocation().search;
    const merchantIdInPayPal = new URLSearchParams(search).get('merchantIdInPayPal');
    const productIntentId = new URLSearchParams(search).get('productIntentId');




    const [values, setValues] = useState({
        name: '',
        userId: _id,
        description: '',
        condition: '',
        size: '',
        brand: '',
        interestedIn: '',
        price: '',
        who_pays:'',
        category: '',
        type: '',
        width: '',
        length: '',
        height: '',
        weight: '',
        primary_photo: '',
        secondary_photos: [],
        loading: false,
        error: '',
        success: false,
        createdProduct: '',
        redirectToProfile: false,
        formData: ''
    });

    const {name, description, condition, size, brand, interestedIn, price,
        who_pays, category, primary_photo, secondary_photos,  loading, success,
        width, length, height, weight,
        error, createdProduct, redirectToProfile, formData, type} = values;

    //load categories and set form data
    const init = () => {
        setValues({...values, formData: new FormData()})
    };

    useEffect(() => {
        init();
        if (merchantIdInPayPal) {
            savePaypal(_id, {merchantIdInPayPal, productIntentId},token).then(data => {
                if (data.error) {
                    console.log(data.error);
                }
                else {
                    setUserInfo({merchantId: merchantIdInPayPal, paypal_onboarded: true});
                }
            });
        }
        else {
            getUserInfo(_id).then(data => {
                if (data.paypal_onboarded) {
                    const { paypal_info: {merchantIdInPayPal, paypal_onboarded }} = data;
                    setUserInfo({
                        merchantId: merchantIdInPayPal, 
                        paypal_onboarded: true,
                    });
                }
            });
        }
    }, []);


    const handleChange = name => event => { //TODO how to handle multiple images?
        const value = name === 'primary_photo' ? event.target.files[0] : event.target.value;
        if (name === 'primary_photo') {
            setPrimaryPreview(URL.createObjectURL(event.target.files[0]))
        }

        formData.set(name, value);
        setValues({...values, [name]: value})
    };

    const handleSelectChange = e => {
        formData.set('brand', e.value);
        setValues({...values, 'brand': e.value})
    };
    const handlePrimaryDropChange = (files, event) => {
        event.preventDefault();
        setPrimaryPreview(URL.createObjectURL(files[0]))
        formData.set('primary_photo',files[0]);
        setValues({...values,primary_photo: files[0]})
    };

    const handleSecondaryDropChange = async (files, event) => {
        event.preventDefault();
        for (let i =0; i < files.length; i++) {
            await formData.append('secondary_photos', files[i]);
            await console.log(files[i]);
            var temp = await URL.createObjectURL(files[i]);
            await setSecondaryPreviews(secondaryPreviews => [...secondaryPreviews, temp])
            await console.log(secondaryPreviews);
        }
    };



    const handleMultipleFiles = async event => {
        const files = event.target.files;
        for (let i =0; i < files.length; i++) {
            await formData.append('secondary_photos', files[i]);
            await console.log(files[i]);
            var temp = await URL.createObjectURL(files[i]);
            await setSecondaryPreviews(secondaryPreviews => [...secondaryPreviews, temp])
            await console.log(secondaryPreviews);
        }
    };



    const goToHome = () => (
        <Link to='/'/>
    );
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const clickSubmit = async event => {
        event.preventDefault();
        if (!priceValidation()) {
            console.log('yo');
            return
        }
        else if (!validateParcelInfo()){
            return
        }
        await formData.append('merchantId', merchantId);
        await formData.append('userId', _id);
        console.log('here');
        setValues({...values, error: '', loading: true});
        createProduct(_id, token, formData)
            .then(data => {
                if(data.error) {
                    scrollToTop();
                    formData.delete('merchantId'); //to prevent creating array
                    formData.delete('userId');
                    setValues({...values, error: data.error, success: false})
                }   
                else {
                    setProductId(data.result._id);
                    handleOpen();
                    setValues({
                        ...values, name: '', description: '', condition: '', size: '',
                        brand: '', interestedIn: '', photo: '', price: '', 
                        quantity: '', success: true, category:'', loading: false, 
                        createdProduct: data.name
                    })
                }
            });
    }; 

    const priceValidation = () => {
        var regex = new RegExp('^(0|[1-9][0-9]{0,2})(,\d{3})*(\.\d{1,2})?')
        if (!price.match(regex)) {
            setValues({...values, error: 'Please enter a valid price', success: false})
            return false;
        } 
        return true;
    };

    const validateParcelInfo = () => {
        if (parseInt(width) < 1 || width === '') {
            setValues({...values, error: 'Please enter a valid width value'});
            return false;
        }
        else if (parseInt(length) < 1 || length === '') {
            setValues({...values, error: 'Please enter a valid length value'});
            return false;
        }
        else if (parseInt(height) < 1|| height === '') {
            setValues({...values, error: 'Please enter a valid height value'});
            return false;
        }
        else if (parseInt(weight) < 0 || weight === '') {
            setValues({...values, error: 'Please enter a valid weight value'});
            return false;
        }
        else {
            return true;
        }
    };
 

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    const showError = () => (
        <div className="rounded-md bg-red-50 p-4" style={{display: error ? '' : 'none'}}>
            <div className="flex">
                <div className="flex-shrink-0">
                    <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
                </div>
                <div className="ml-3">
                    <h3 className="text-sm font-medium text-red-800">There was an error with your submission</h3>
                    <div className="mt-2 text-sm text-red-700">
                        <p className='pl-5 space-y-1'> {error} </p>
                    </div>
                </div>
            </div>
        </div>
    );



    const showLoading = () =>
        loading && (
            <div className="alet alert-success">
                <h2>Loading...</h2>
            </div>
        );

    const Sizing = () => {
        if (category === '') {
            return (
                <option>Please select category first</option>
            );
        }
        else if (category === 'shoes') {
            return (
                <Fragment>
                    <option>Please Select</option>
                    <option value='3.5'>3.5</option>
                    <option value='4'>4</option>
                    <option value='4.5'>4.5</option>
                    <option value='5'>5</option>
                    <option value='5.5'>5.5</option>
                    <option value='6'>6</option>
                    <option value='6.5'>6.5</option>
                    <option value='7'>7</option>
                    <option value='7.5'>7.5</option>
                    <option value='8'>8</option>
                    <option value='8.5'>8.5</option>
                    <option value='9'>9</option>
                    <option value='9.5'>9.5</option>
                    <option value='10'>10</option>
                    <option value='10.5'>10.5</option>
                    <option value='11'>11</option>
                    <option value='11.5'>11.5</option>
                    <option value='12'>12</option>
                    <option value='12.5'>12.5</option>
                    <option value='13'>13</option>
                    <option value='13.5'>13.5</option>
                    <option value='14'>14</option>
                </Fragment>
            );
        }
        else if (category === 'shirts' || category === 'jackets') {
            return (
                <Fragment>
                    <option>Please Select</option>
                    <option value='XS'>XS</option>
                    <option value='S'>S</option>
                    <option value='M'>M</option>
                    <option value='L'>L</option>
                    <option value='XL'>XL</option>
                </Fragment>
            );
        }
        else if (category === 'pants' || category === 'shorts') {
            return (
                <Fragment>
                    <option>Please Select</option>
                    <option value='XS'>XS</option>
                    <option value='S'>S</option>
                    <option value='M'>M</option>
                    <option value='L'>L</option>
                    <option value='XL'>XL</option>
                    <option value='26'>26</option>
                    <option value='27'>27</option>
                    <option value='28'>28</option>
                    <option value='29'>29</option>
                    <option value='30'>30</option>
                    <option value='31'>31</option>
                    <option value='32'>32</option>
                    <option value='33'>33</option>
                    <option value='34'>34</option>
                    <option value='35'>35</option>
                    <option value='36'>36</option>
                    <option value='37'>37</option>
                    <option value='38'>38</option>
                    <option value='39'>39</option>
                    <option value='40'>40</option>
                    <option value='41'>41</option>
                    <option value='42'>42</option>
                    <option value='43'>43</option>
                    <option value='44'>44</option>
                </Fragment>
            );
        }
        else if (category === 'hats') {
            return (
                <Fragment>
                    <option>Please Select</option>
                    <option value='ONE SIZE'>ONE SIZE</option>
                    <option value='6 3/4'>6 3/4</option>
                    <option value='6 7/8'>6 7/8</option>
                    <option value='7'>7</option>
                    <option value='7 1/8'>7 1/8</option>
                    <option value='7 1/4'>7 1/4</option>
                    <option value='7 3/8'>7 3/8</option>
                    <option value='7 1/2'>7 1/2</option>
                    <option value='7 5/8'>7 5/8</option>
                    <option value='7 3/4'>7 3/4</option>
                    <option value='7 7/8'>7 7/8</option>
                    <option value='8'>8</option>
                    <option value='8 1/8'>8 1/8</option>
                    <option value='8 1/4'>8 1/4</option>
                </Fragment>
            );
        }
        else {
            return (
                <option>Please select category first</option>
            );
        };
    };

    const PrimaryPhotoForm = () => {
        if (primaryPreview) {
            return (
                <div className='aspect-square block sm:col-span-2 space-y-2'>
                    <label htmlFor="cover-photo" className="text-sm font-medium text-gray-700">
                        Primary Photo
                    </label>

                    <img 
                        src={primaryPreview}
                        className='aspect-square object-contain shadow-lg rounded-lg w-9/12 h-auto'
                    />
                    <label
                        htmlFor="file-upload"
                        className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                    >
                        <span>Choose again </span>
                        <input 
                            id="file-upload" 
                            name="file-upload" 
                            onChange={handleChange('primary_photo')}
                            type="file" 
                            accept='image/*'
                            className="sr-only" 
                        />
                    </label>
                </div>


            );
        }
        else {
            return (
                <FileDrop 
                    className='sm:col-span-2'
                    onDrop={handlePrimaryDropChange}
                >
                    <label htmlFor="cover-photo" className="block text-sm font-medium text-gray-700">
                        Primary Photo
                    </label>
                    <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                        <div className="space-y-1 text-center">
                            <svg
                                className="mx-auto h-12 w-12 text-gray-400"
                                stroke="currentColor"
                                fill="none"
                                viewBox="0 0 48 48"
                                aria-hidden="true"
                            >
                                <path
                                    d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <div className="flex text-sm text-gray-600">
                                <label
                                    htmlFor="file-upload"
                                    className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                                >
                                    <span>Upload a file</span>
                                    <input 
                                        id="file-upload" 
                                        name="file-upload" 
                                        onChange={handleChange('primary_photo')}
                                        type="file" 
                                        accept='image/*'
                                        className="sr-only" 
                                    />
                                </label>
                            </div>
                            <p className="text-xs text-gray-500">up to 20MB</p>
                        </div>
                    </div>
                </FileDrop>
            );
        }
    };

    const SecondaryPhotoForm = () => {
        if (secondaryPreviews.length != 0) {
            return (
                <div className='sm:col-span-4'>
                    <label htmlFor="secondary-photos" className="block text-sm font-medium text-gray-700">
                        Secondary Photos
                    </label>
                    <ul role="list" className="grid grid-cols-3 gap-x-1 gap-y-4 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
                        {secondaryPreviews.map((file,i) => (
                            <li key={i} className="relative">
                                <div className="group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-indigo-500 overflow-hidden">
                                    <img src={file} alt="" className="object-cover pointer-events-none group-hover:opacity-75" />
                                </div>
                            </li>
                        ))}
                    </ul>

                    <label
                        htmlFor="file-uploads"
                        className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                    >
                        <span>Choose Again</span>
                        <input 
                            id="file-uploads" 
                            name="file-uploads" 
                            onChange={handleMultipleFiles}
                            accept='image/*'
                            multiple
                            type="file" 
                            className="sr-only" />
                    </label>

                </div>

            );
        }
        else {
            return(
                <div className="sm:col-span-4">
                    <FileDrop className='sm:col-span-4' onDrop={handleSecondaryDropChange}>
                        <label htmlFor="cover-photo" className="block text-sm font-medium text-gray-700">
                            Secondary Photos
                        </label>
                        <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                            <div className="space-y-1 text-center">
                                <svg
                                    className="mx-auto h-12 w-12 text-gray-400"
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 48 48"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <div className="flex text-sm text-gray-600">
                                    <label
                                        htmlFor="file-uploads"
                                        className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                                    >
                                        <span>Upload multiple files</span>
                                        <input 
                                            id="file-uploads" 
                                            name="file-uploads" 
                                            onChange={handleMultipleFiles}
                                            accept='image/*'
                                            multiple
                                            type="file" 
                                            className="sr-only" />
                                    </label>
                                </div>
                                <p className="text-xs text-gray-500">up to 20MB</p>
                            </div>
                        </div>
                    </FileDrop>
                </div>

            );
        }
    };

    const PackageDim = () => (
        <>
            <label htmlFor='package-dim' className='text-sm font-medium text-gray-700 sm:col-span-6'>
                Shipping Box Dimensions
            </label>

            <div className='sm:col-span-1'>
                <label htmlFor='width' className='block text-xs font-normal text-gray-600'>
                    Width (in)
                </label>
                <input
                    className='focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md max-w-xs'
                    onChange={handleChange('width')}
                    value={width}
                    type='number'
                    name='width'
                    id='width'
                />
            </div>
            <div className='sm:col-span-1'>
                <label htmlFor='height' className='block text-xs font-normal text-gray-600'>
                    Height (in)
                </label>
                <input
                    className='focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md max-w-xs'
                    onChange={handleChange('height')}
                    value={height}
                    type='number'
                    name='height'
                    id='height'
                />
            </div>

            <div className='sm:col-span-4'>
            </div>

            <div className='sm:col-span-1'>
                <label htmlFor='length' className='block text-xs font-normal text-gray-600'>
                    Length (in)
                </label>
                <input
                    className='focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md max-w-xs'
                    onChange={handleChange('length')}
                    value={length}
                    type='number'
                    name='length'
                    id='length'
                />
            </div>
            <div className='sm:col-span-1'>
                <label htmlFor='weight' className='block text-xs font-normal text-gray-600'>
                    Weight (lb)
                </label>
                <input
                    className='focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md max-w-xs'
                    onChange={handleChange('weight')}
                    value={weight}
                    type='number'
                    name='weight'
                    id='weight'
                />
            </div>

            <div className='sm:col-span-3'>

            </div>

        </>
    );

    const newPostForm = () => (
        <form 
            className={`${paypal_onboarded ? '' : 'blur-[3px]'} space-y-8 divide-y divide-gray-200 px-8 lg:px-40 py-12 sm:px-10 sm-py-5`}
            onSubmit={clickSubmit}
        >
            <div className="space-y-8 divide-y divide-gray-200">
                <div>
                    <div>
                        <h3 className="text-lg leading-6 font-medium text-gray-900">Add Loot</h3>
                        <p className="mt-1 text-sm text-gray-500">
                        </p>
                    </div>

                    <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                        <div className='sm:col-span-3'>
                            <label htmlFor="size" className="block text-sm font-medium text-gray-700">
                                Category
                            </label>
                            <div className="mt-1">
                                <select
                                    disabled={!paypal_onboarded}
                                    id="category"
                                    onChange={handleChange('category')}
                                    value={category}
                                    name="category"
                                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                >
                                    <option> Please Select </option>
                                    <option value='shoes'> Shoes </option>
                                    <option value='shirts'>Shirts</option>
                                    <option value='jackets'>Jackets</option>
                                    <option value='pants'>Pants</option>
                                    <option value='shorts'>Shorts</option>
                                    <option value='hats'> Hats</option>
                                </select>
                            </div>
                        </div>


                        <div className="sm:col-span-3">
                            <label htmlFor="username" className="block text-sm font-medium text-gray-700">
                                Item name
                            </label>
                            <div className="mt-1 flex rounded-md shadow-sm">
                                <input
                                    disabled={!paypal_onboarded}
                                    type="text"
                                    onChange={handleChange('name')}
                                    value={name}
                                    name="name"
                                    id="name"
                                    className="flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-md sm:text-sm border-gray-300"
                                />
                            </div>
                        </div>

                        <div className="sm:col-span-3">
                            <label htmlFor="brand" className="block text-sm font-medium text-gray-700">
                                Brand
                            </label>
                            <div className="mt-1 flex rounded-md shadow-sm">
                                <Select
                                    disabled={!paypal_onboarded}
                                    onChange={handleSelectChange}
                                    placeholder='Search for brands'
                                    options={brands}
                                    name="brand"
                                    id="brand"
                                    className="flex-1 block w-full min-w-0 rounded-md sm:text-sm border-gray-300" />
                            </div>
                        </div>

                        <div className='sm:col-span-3'>
                            <label htmlFor="size" className="block text-sm font-medium text-gray-700">
                                Size
                            </label>
                            <div className="mt-1">
                                <select
                                    id="size"
                                    disabled={!paypal_onboarded}
                                    onChange={handleChange('size')}
                                    value={size}
                                    name="size"
                                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                >
                                    <Sizing/>
                                </select>
                            </div>
                        </div>

                        <div className='sm:col-span-3'>
                            <label htmlFor="condition" className="block text-sm font-medium text-gray-700">
                                Condition
                            </label>
                            <div className="mt-1">
                                <select
                                    id="condition"
                                    disabled={!paypal_onboarded}
                                    onChange={handleChange('condition')}
                                    value={condition}
                                    name="condition"
                                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                >
                                    <option> Please Select </option>
                                    <option value='New with box'>New with box</option>
                                    <option value='New without box'>New without box</option>
                                    <option value='New with defects'>New with defects</option>
                                    <option value='Pre-owned'>Pre-owned</option>
                                </select>
                            </div> 
                        </div>



                        <div className="sm:col-span-6">
                            <label htmlFor="about" className="block text-sm font-medium text-gray-700">
                                Description
                            </label>
                            <div className="mt-1">
                                <textarea
                                    id="description"
                                    disabled={!paypal_onboarded}
                                    onChange={handleChange('description')}
                                    value={description}
                                    name="description"
                                    rows={2}
                                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"
                                    defaultValue={''}
                                />
                            </div>
                            <p className="mt-2 text-sm text-gray-500">Write a few sentences about the product.</p>
                        </div>

                        <div className='sm:col-span-2'>
                            <label htmlFor="price" className="block text-sm font-medium text-gray-700">
                                Price
                            </label>
                            <div className="mt-1 relative rounded-md shadow-sm">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <span className="text-gray-500 sm:text-sm">$</span>
                                </div>
                                <input
                                    disabled={!paypal_onboarded}
                                    onChange={handleChange('price')} 
                                    value={price}
                                    type="number"
                                    min='0.00'
                                    max='100000.00'
                                    step='0.01'
                                    name="price"
                                    id="price"
                                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
                                    placeholder="0.00"
                                    aria-describedby="price-currency"
                                />
                                <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                    <span className="text-gray-500 sm:text-sm" id="price-currency">
                                        USD
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className='sm:col-span-3'> {/* Intentionally blank */}
                        </div>
                        <div className='sm:col-span-6'> {/* Intentionally blank */}

                        </div>

                        {/* Package dimensions */}
                        <>
                            <label htmlFor='package-dim' className='text-sm font-medium text-gray-700 sm:col-span-6'>
                                Shipping Box Dimensions
                            </label>

                            <div className='sm:col-span-1'>
                                <label htmlFor='width' className='block text-xs font-normal text-gray-600'>
                                    Width (in)
                                </label>
                                <input
                                    className='focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md max-w-xs'
                                    onChange={handleChange('width')}
                                    value={width}
                                    type='number'
                                    name='width'
                                    id='width'
                                />
                            </div>
                            <div className='sm:col-span-1'>
                                <label htmlFor='height' className='block text-xs font-normal text-gray-600'>
                                    Height (in)
                                </label>
                                <input
                                    className='focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md max-w-xs'
                                    onChange={handleChange('height')}
                                    value={height}
                                    type='number'
                                    name='height'
                                    id='height'
                                />
                            </div>

                            <div className='sm:col-span-4'>
                            </div>

                            <div className='sm:col-span-1'>
                                <label htmlFor='length' className='block text-xs font-normal text-gray-600'>
                                    Length (in)
                                </label>
                                <input
                                    className='focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md max-w-xs'
                                    onChange={handleChange('length')}
                                    value={length}
                                    type='number'
                                    name='length'
                                    id='length'
                                />
                            </div>
                            <div className='sm:col-span-1'>
                                <label htmlFor='weight' className='block text-xs font-normal text-gray-600'>
                                    Weight (lb)
                                </label>
                                <input
                                    className='focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md max-w-xs'
                                    onChange={handleChange('weight')}
                                    value={weight}
                                    type='number'
                                    name='weight'
                                    id='weight'
                                />
                            </div>

                            <div className='sm:col-span-3'>

                            </div>

                        </>


                        <PrimaryPhotoForm/>

                        <SecondaryPhotoForm/>
                    </div>
                </div>

                <div className="pt-8 space-y-5">
                    <div>
                        <div className="sm:col-span-6">
                            <label htmlFor="interestedIn" className="block text-sm font-medium text-gray-700">
                                (Optional) Are there any particular items you wish to trade this item for?
                            </label>
                            <div className="mt-1">
                                <textarea
                                    disabled={!paypal_onboarded}
                                    id="interestedIn"
                                    onChange={handleChange('interestedIn')}
                                    value={interestedIn}
                                    name="interestedIn"
                                    rows={2}
                                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"
                                    defaultValue={''}
                                />
                            </div>
                        </div>


                    </div>
                    <div
                        className="text-base font-large text-gray-900 sm:text-md sm:text-black"
                    >
                        <h2>  Trade Options </h2>
                    </div>
                    <div className="mt-6">
                        <div className="sm:col-span-2">
                            <div className="max-w-lg">
                                <div className="mt-4 space-y-4">
                                    <div className="flex items-center">
                                        <input
                                            id='trade-sell'
                                            disabled={!paypal_onboarded}
                                            name='trade-type'
                                            onChange={handleChange('type')}
                                            value={'trade-sell'}
                                            type="radio"
                                            className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                                        />
                                        <label htmlFor="trade-sell" className="ml-3 block text-sm font-medium text-gray-700">
                                            Trade and Sell
                                        </label>
                                    </div>
                                    <div className="flex items-center">
                                        <input
                                            disabled={!paypal_onboarded}
                                            id='trade-only'
                                            name='trade-type'
                                            onChange={handleChange('type')}
                                            value={'trade-only'}
                                            type="radio"
                                            className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                                        />
                                        <label htmlFor="trade-only" className="ml-3 block text-sm font-medium text-gray-700">
                                            Trade Only
                                        </label>
                                    </div>
                                    <div className="flex items-center">
                                        <input
                                            id='sell-only'
                                            disabled={!paypal_onboarded}
                                            name='trade-type'
                                            onChange={handleChange('type')}
                                            value={'sell-only'}
                                            type="radio"
                                            className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                                        />
                                        <label htmlFor="sell-only" className="ml-3 block text-sm font-medium text-gray-700">
                                            Sell Only
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className={`${type === 'trade-only' || type === '' ? 'hidden' : ''}`}>
                        <div
                            className="text-base font-large text-gray-900 sm:text-md sm:text-black border-t"
                        >
                            <h2 className='mt-4'> Who Pays for Shipping? </h2>
                            <p className="mt-1 text-sm text-gray-500">
                                This option only applies if someone buys your item, not for trades
                            </p>

                        </div>

                        <div className="mt-4">
                            <div className="sm:col-span-2">
                                <div className="max-w-lg">
                                    <div className="mt-4 space-y-4">
                                        <div className="flex items-center">
                                            <input
                                                id='who-pays'
                                                disabled={!paypal_onboarded}
                                                name='who-pays'
                                                onChange={handleChange('who_pays')}
                                                value={'buyer-pays'}
                                                type="radio"
                                                className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                                            />
                                            <label htmlFor="trade-sell" className="ml-3 block text-sm font-medium text-gray-700">
                                                Buyer will pay
                                            </label>
                                        </div>
                                        <div className="flex items-center">
                                            <input
                                                disabled={!paypal_onboarded}
                                                id='who-pays'
                                                name='who-pays'
                                                onChange={handleChange('who_pays')}
                                                value={'seller-pays'}
                                                type="radio"
                                                className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                                            />
                                            <label htmlFor="trade-only" className="ml-3 block text-sm font-medium text-gray-700">
                                                I will pay
                                                <p className='text-gray-500 text-xs font-normal'>Pay shipping costs based on buyers location </p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

            <div className="pt-5">
                <div className="flex justify-end">
                    <button
                        className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        List Loot
                    </button>
                </div>
            </div>
        </form>
    );

    return (
        <>
            <SuccessModal 
                title='Success!' 
                link={`/loot/${productId}`}
                description='You item has been listed on the market' open={open} handleClose={handleClose}/>
            <Layout>
                {!paypal_onboarded && 
                <LinkPaypal/>
                }
                {showError()}
                {newPostForm()}
            </Layout>
        </>
    );
};

export default AddProduct;

